import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { useLogErrorPublicWeb } from '@telialt/utils/src/datadog/useLogError';
import { useSegment } from '@telialt/utils/src/segment';

import { apiPostLead } from '../api';
import { MUTATION_KEY } from '../constants';
import { LeadFormData, LeadSubmitResponse } from '../model';
import { mapLeadFormDataToSubmitData } from '../utils';

export const useLeadSubmit = () => {
    const segment = useSegment();

    const {
        mutate: submitLead,
        reset: resetSubmitLead,
        status,
        error,
        isSuccess,
        isError,
        isPending,
    } = useMutation<AxiosResponse<LeadSubmitResponse>, AxiosError, LeadFormData>({
        mutationFn: (formData) => {
            const submitData = mapLeadFormDataToSubmitData(segment, formData);

            return apiPostLead(segment, submitData);
        },
        mutationKey: [MUTATION_KEY.SUBMIT_LEAD, segment],
    });
    useLogErrorPublicWeb(error);

    return { submitLead, resetSubmitLead, status, error, isSuccess, isError, isPending };
};
